<p class="subtitle is-1">{{ ('data-processing-agreement') | translate }}</p>
